import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { CoreStateService, ScheduleService, SchoolService } from '@app/core/services';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, map, Observable, of, Subject, switchMap, takeUntil } from 'rxjs';
import { ChatbotTipo } from '@app/core/utils/chatbot.script';
@Component({
  templateUrl: './scaffold.component.html',
  styleUrls: ['./scaffold.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScaffoldComponent implements OnInit, OnDestroy {
  public isScrollTop = true;
  public isFloatMenu$: Observable<boolean>;
  public data$: Observable<any>;
  public whatsapp$: Observable<any>;

  private _destroy$ = new Subject<void>();

  constructor(
    private escolaService: SchoolService,
    private coreStateService: CoreStateService,
    private breakpointObserver: BreakpointObserver,
    private translateService: TranslateService,
    private scheduleService: ScheduleService,
  ) {}

  @HostListener('window:scroll', ['$event'])
  public windowScroll() {
    this.isScrollTop = !window.pageYOffset;
  }

  public ngOnInit() {
    this.isFloatMenu$ = this.breakpointObserver.observe('(min-width: 1280px)').pipe(
      takeUntil(this._destroy$),
      map((state) => state.matches),
    );
    this.data$ = this.coreStateService.state$.pipe(
      switchMap((config) =>
        forkJoin({
          menuMore: this.escolaService.menuMore(config.school.id),
          school: of(config.school),
          pedagogical: of(config.plugin.handler.scaffold.pedagogical(config.school)),
          enrolment: of(config.plugin.enrollment && config.plugin.enrollment(config.school)),
          whatsapp: this.escolaService
            .chatbot(config.school.id)
            .pipe(map((res) => (res.data?.tipo === ChatbotTipo.Whatsapp && !!res.data.status ? res.data : null))),
        }),
      ),
    );
  }

  public ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public onBackToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  public onWhatsLink(data: any) {
    const text = this.translateService.instant('contact.whatsapp-text', { schoolName: data.school.nome });
    const chave = data.whatsapp.chave.replaceAll(/\D/g, '');
    this.scheduleService.schedulingWhatsapp(text, chave);
  }
}
